var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "space-between" }
        },
        [
          _c("cargo-input", {
            staticStyle: {
              width: "115px",
              "margin-right": "5px",
              "flex-grow": "1"
            },
            attrs: {
              placeholder: _vm.disabled ? "" : _vm.$t("SeaExport.ConsigneeId"),
              "auto-uppercase": _vm.autoUppercase,
              disabled: _vm.disabled
            },
            on: {
              change: function($event) {
                return _vm.onChange("consigneeCode")
              }
            },
            model: {
              value: _vm.job.consigneeCode,
              callback: function($$v) {
                _vm.$set(_vm.job, "consigneeCode", $$v)
              },
              expression: "job.consigneeCode"
            }
          }),
          _c("cargo-company-select", {
            staticStyle: {
              display: "inline-block",
              width: "145px",
              "flex-grow": "1"
            },
            attrs: {
              disabled: _vm.disabled,
              "method-params": { consignee: true, active: true },
              "default-value": _vm.job.consigneeId || ""
            },
            on: { change: _vm.consigneeChange }
          })
        ],
        1
      ),
      _vm._l(7, function(i) {
        return _c("cargo-input", {
          key: i,
          staticStyle: { "margin-top": "5px" },
          attrs: {
            "use-read-only": true,
            disabled: _vm.disabled,
            "auto-uppercase": _vm.autoUppercase
          },
          on: {
            change: function($event) {
              return _vm.onChange("consigneeLine" + i)
            }
          },
          nativeOn: {
            dblclick: function($event) {
              _vm.showAdvanceTextDialog(
                _vm.$t("SeaExport.Consignee"),
                _vm.mergeConsigneeLine(),
                _vm.splitConsigneeLine,
                _vm.autoUppercase,
                { autoHalfWord: true, autoUppercase: _vm.autoUppercase }
              )
            }
          },
          model: {
            value: _vm.job["consigneeLine" + i],
            callback: function($$v) {
              _vm.$set(_vm.job, "consigneeLine" + i, $$v)
            },
            expression: "job['consigneeLine'+i]"
          }
        })
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceTextDialog",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            },
            close: _vm.closeAdvanceText
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              no: "advanceTextDialogTextarea",
              disabled: _vm.disabled,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.disabled,
                      expression: "!disabled"
                    }
                  ],
                  attrs: { no: "advanceTextDialogConfirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "advanceTextDialogClose" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                      _vm.closeAdvanceText()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }